export enum WizardInputOptionsType {
    entityType = 'entityType',
    commentaryType = 'commentaryType',
    disclaimerType = 'disclaimerType',
    property = 'property',
    statisticCode = 'statisticCode',
    allocationCode = 'allocationCode',
    timeseriesCode = 'timeseriesCode',
    statisticProperty = 'statisticProperty',
    allocationProperty = 'allocationProperty',
    timeseriesProperty = 'timeseriesProperty',
}